import type { OutlookSpaceAsset, TimeStreamProject } from 'owa-timestream-types';
import updateAssetChildren from '../assets/updateAssetChildren';
import updateAssets from '../assets/updateAssets';
import updateRenderingOrder from './updateRenderingOrder';

export default function updateProjetAssets(
    project: TimeStreamProject,
    outlookSpaceAssets?: OutlookSpaceAsset[]
) {
    if (outlookSpaceAssets) {
        const { assets } = project;
        updateAssets(assets, outlookSpaceAssets);
        updateAssetChildren(assets);
        updateRenderingOrder(project);
    }
}
